module.exports = __webpack_public_path__ + "img/Clients.c85ed089.svg";